export default __webpack_public_path__ + "static/media/email.51a329c6.svg";